import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';
import ImageView from 'lib/images/image-view';

import deleteIcon from 'four-nets/icons/svg/icon_delete.svg';
import closeIcon from 'four-nets/icons/svg/icon_close.svg';
import like from 'four-nets/icons/svg/icon_like-2.svg';
import others from 'four-nets/icons/svg/icon_others.svg';
import comment from 'four-nets/icons/svg/icon_comment.svg';
import userIcon from 'four-nets/icons/svg/icon_user.svg';
import { displayedName } from 'four-nets/user/utils';

import { CollectionImageFragment } from '../../collection/collection-image/collection-image.graphql';
import defaultStyles from './collection-edit-image.scss';

import { FormattedMessage } from 'react-intl';

export interface Props extends CollectionImageFragment {
    styles: typeof defaultStyles;
    onClick: (id: string) => void;
    selected: boolean;
}

interface State {
    open: boolean;
}

class CollectionImage extends React.PureComponent<Props, State> {
    state: State = { open: false };

    render() {
        const { styles, selected, onClick, ...collectionImage } = this.props;
        return (
            <div className={classnames(styles.collectionImage, { [styles.selected]: selected })}>
                <div className={styles.imageWrapper}>
                    <ImageView {...collectionImage.image.photoFile} sizes={{ xs: 250 }} aspectFill={true} />
                    <button
                        type='button'
                        onClick={() => this.setState(prevState => ({ open: !prevState.open }))}
                        className={styles.othersButton}
                    >
                        <SVGIcon src={others} className={styles.othersIcon} />
                    </button>
                    <div className={classnames(styles.drawer, { [styles.open]: this.state.open })}>
                        <div className={styles.square} />
                        <button
                            type='button'
                            className={styles.button}
                            onClick={() => {
                                onClick(collectionImage.id);
                                this.setState({ open: false });
                            }}
                        >
                            <SVGIcon src={selected ? closeIcon : deleteIcon} className={styles.deleteIcon} />
                            {selected ? <FormattedMessage id='BACK' /> : <FormattedMessage id='DELETE_IMAGE' />}
                        </button>
                    </div>
                    <div className={styles.stats}>
                        <div className={styles.statsRow}>
                            <div className={styles.stat}>
                                <SVGIcon src={like} className={styles.statIcon} />
                                {collectionImage.image.likesCount || 0}
                            </div>
                            <div className={styles.stat}>
                                <SVGIcon src={comment} className={styles.statIcon} />
                                {collectionImage.image.commentCount || 0}
                            </div>
                        </div>
                    </div>
                </div>
                <Link to={collectionImage.image.post.href!} className={styles.postTitle}>
                    {collectionImage.image.post.title}
                </Link>
                <Link
                    to={(collectionImage.image.post.user && collectionImage.image.post.user.href) || ''}
                    className={styles.user}
                >
                    <SVGIcon src={userIcon} className={styles.icon} />
                    {collectionImage.image.post.user && displayedName(collectionImage.image.post.user)}
                </Link>
            </div>
        );
    }
}

export default Styled(defaultStyles)(CollectionImage);
